export default __webpack_public_path__ + "static/media/login.2252520e.jpg";